// frontend/src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = () => {
  const { user } = useContext(AuthContext);

  // If the user is authenticated, render the nested content (`<Outlet />`).
  // Otherwise, redirect them to the login page.
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;